
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 6h4v2h-4zm6 0h4v2h-4zm10 0v8h-6v-2h4V8h-2V6zm-18 6h4v2h-4zm6 0h4v2h-4zM6 8v4h2v2H4V6h6v2zm6 10h4v2h-4zm6 0h4v2h-4zm10 0v8h-6v-2h4v-4h-2v-2zm-18 6h4v2h-4zm6 0h4v2h-4zM6 20v4h2v2H4v-8h6v2zM30 2H2v28h28V2zm2-2v32H0V0h32z"}})])
          )
        }
      }
    